import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { SelectedProducts, DetailRow } from './components';

/**
 * Shared ViewOrderHeader. Renders order ID, business name, products, and status using config.
 * @param {Object} orderData - Order object
 * @param {Object} labels - { orderIdLabel, businessNameLabel, productsLabel, statusLabel, statusTextMap }
 *   statusTextMap: { [statusValue]: string } for mapping status codes to display text
 * @param {Object} fieldMapping - Keys in orderData: { orderId, businessName, products, status }
 * @param {Function} getBusinessName - Optional (orderData) => string for computed business name (e.g. fallbacks)
 */
const ViewOrderHeader = ({
  orderData,
  labels,
  fieldMapping,
  getBusinessName
}) => {
  const {
    orderId: orderIdKey,
    businessName: businessNameKey,
    products: productsKey,
    status: statusKey
  } = fieldMapping;

  const orderIdValue = orderData[orderIdKey];
  const businessNameValue = getBusinessName
    ? getBusinessName(orderData)
    : orderData[businessNameKey];
  const products = productsKey ? orderData[productsKey] : null;
  const statusValue = orderData[statusKey];
  const statusDisplay =
    (labels.statusTextMap && labels.statusTextMap[statusValue]) || statusValue;

  return (
    <Fragment>
      <DetailRow label={labels.orderIdLabel} value={orderIdValue} />
      <DetailRow label={labels.businessNameLabel} value={businessNameValue} />
      {productsKey && (
        <SelectedProducts products={products} label={labels.productsLabel} />
      )}
      <DetailRow label={labels.statusLabel} value={statusDisplay} />
    </Fragment>
  );
};

ViewOrderHeader.propTypes = {
  orderData: PropTypes.object.isRequired,
  labels: PropTypes.shape({
    orderIdLabel: PropTypes.string.isRequired,
    businessNameLabel: PropTypes.string.isRequired,
    productsLabel: PropTypes.string,
    statusLabel: PropTypes.string.isRequired,
    statusTextMap: PropTypes.object
  }).isRequired,
  fieldMapping: PropTypes.shape({
    orderId: PropTypes.string.isRequired,
    businessName: PropTypes.string.isRequired,
    products: PropTypes.string,
    status: PropTypes.string.isRequired
  }).isRequired,
  getBusinessName: PropTypes.func
};

export default ViewOrderHeader;
